import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from './CenteredSpinner';
import fire from '../images/fire.svg';
import ScrollToTop from 'react-scroll-to-top';
import { useQuery } from 'react-query';
import { PropertyCard } from './PropertyCard';

export const HotProperties = () => {
  const [search, setSearch] = useState('');
  const location = useLocation();
  const [forSaleOrToLet, setForSaleOrToLet] = useState(null);
  //forSaleOrToLet Reference
  const saleOrLet = useRef();
  saleOrLet.current = forSaleOrToLet;
  const navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem('token');
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Hot Properties';
    window.scrollTo(0, 0);
    refetch();
  }, [forSaleOrToLet]);

  const fetchHotProperties = () => {
    let filterSaleOrLet = null;
    if (forSaleOrToLet != null) {
      forSaleOrToLet === "true" ? filterSaleOrLet = true : filterSaleOrLet = false;
    }

    const options = {
      method: 'POST',
      url: '/property/gethotproperties',
      headers: {
        Accept: 'application/json',
      },
      data: {
        includeImgs: true,
        forSaleOrToLet: saleOrLet.current
      },
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const {
    isLoading,
    isError,
    data: HotPropertiesData,
    refetch
  } = useQuery(['HotProperties'], fetchHotProperties, {
    refetchOnWindowFocus: false,
    enabled: false // turned off by default, manual refetch is needed
  });

  const handleForSaleOrToLetChange = (event) => {
    event.preventDefault();
    event.persist();
    if (forSaleOrToLet == event.target.dataset.forsaleortolet) {
      setForSaleOrToLet(null);
      return;
    }
    setForSaleOrToLet(event.target.dataset.forsaleortolet);
  };

  const filterHotProperties = (HotProperties, search) => {
    if (!search) {
      return HotProperties;
    }

    return HotProperties.filter((hotProperty) => {
      return (
        hotProperty?.propertyTypeName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        hotProperty?.localityName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        hotProperty?.propertyStateName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        hotProperty?.propertyRef.includes(search)
      );
    });
  };

  const filterHotProperty = filterHotProperties(
    HotPropertiesData,
    search,
  );

  if (isLoading) {
    return <CenteredSpinner />;
  }

  if (isError) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="container vh-100">
      <ScrollToTop smooth color="#6f00ff" />
      <div className='row'>
        <div className="col-9 col-xl-9 col-xl-9 ml-0 p-0">
          <div className="h4 mb-3 ml-0 font-weight-bold">
            <img
              className="mr-1"
              src={fire}
              alt="fireFontAwesomePro"
              style={{ width: '25px', height: '25px' }}
            ></img>
              Hot Properties
          </div>
        </div>
        <div className="col-3 col-md-3 col-xl-3 text-right">
          <p className="btn btn-outline-secondary d-block" onClick={() => navigate(-1)}>
            <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
            Back
          </p>
        </div>
      </div>
      
      <div className="col-12 col-xl-8 col-xl-6 ml-0 p-0">
        <div className="h6 mb-3 ml-0">
          You have{' '}
          {filterHotProperty?.length > 1
            ? `${filterHotProperty?.length} listed properties`
            : `${filterHotProperty?.length} listed property`}{' '}
          <i className="fas fa-home"></i>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8">
          <div className="form-group has-search w-100">
            <span className="fa fa-search form-control-feedback"></span>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="d-flex justify-content-center align-items-center">
            <div
              className={`button-belair w-100 ${
                forSaleOrToLet === 'false' ? 'blend' : ''
              }`}
              onClick={handleForSaleOrToLetChange}
              data-forSaleOrToLet="false"
            >
              For-Sale
            </div>
            <div
              className={`button-belair w-100 ${
                forSaleOrToLet === 'true' ? 'blend' : ''
              }`}
              onClick={handleForSaleOrToLetChange}
              data-forSaleOrToLet="true"
            >
              To-Let
            </div>
          </div>
        </div>
        {filterHotProperty?.length < 1 ? (
          <h4 className="mx-auto">No search results found</h4>
        ) : null}
        <div className="container pl-0 pr-0">
          <div className="row mb-4">
            {filterHotProperty &&
              React.Children.toArray(
                filterHotProperty?.map((property, index) => (
                  <PropertyCard
                    property={property}
                    index={index}
                    location={location}
                  />
                )),
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
